import { useGetCatalogQuery, useMembersQuery, useWorkspaceDirectoryQuery } from '@platform/state/api';
import type { IWorkspaceCounts } from './IWorkspaceCounts';
import { recordTypeTotal } from './recordTypeTotal';
import { workspaceCatalog } from './workspaceCatalog';

/**
 * «N учасників · M модулів» простору для перемикача й навігатора просторів: з каталогу платформи (GET /workspaces/directory — `members` і
 * `modules` у значенні прототипу, ознака — поле `modulePackages`), одним запитом на всі простори; старіший сервер — учасники й каталог
 * простору окремими запитами (M — типи записів установлених модулів).
 */
export function useWorkspaceCounts(id: string, parliament: boolean): IWorkspaceCounts {
  const { data: dir, isLoading } = useWorkspaceDirectoryQuery();
  const item = dir?.items.find((w) => w.id === id);
  const fresh = !!item && 'modulePackages' in item;
  const fallback = !isLoading && !fresh;
  const { data: members } = useMembersQuery(id, { skip: !fallback });
  const { data: catalog } = useGetCatalogQuery({ workspaceId: id }, { skip: !fallback });
  if (fresh) return { members: item.members, modules: item.modules };
  return { members: members?.length, modules: recordTypeTotal(workspaceCatalog(catalog, parliament)) };
}
